import { cva } from '@/styled-system/css';

export const buttonLoadingRecipe = cva({
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    inset: '0',
    zIndex: 2,
  },
});
